module.exports = __webpack_public_path__ + "ca435d36c4a2636630871b3f94d3e493.png";